export const hotComics = [
  {
    id: 1,
    title: "我的野蛮王妃",
    author: "朴秀珍",
    category: "恋爱",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20girl%20and%20prince%20in%20palace%20setting%2C%20soft%20pastel%20colors%2C%20elegant%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20floral%20elements%2C%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20professional%20manga%20style%20cover&width=800&height=1120&seq=comic-cover-01&orientation=portrait",
    rating: 9.7,
    views: "1280万",
    latestChapter: "第203话",
    updateDate: "2026-07-07",
    description: "普通女高中生意外成为王室王妃，与冷酷王子的浪漫爱情故事就此展开。宫廷斗争与甜蜜恋爱交织，带你体验不一样的王室罗曼史。",
    tags: ["恋爱", "宫廷", "校园"]
  },
  {
    id: 2,
    title: "剑与魔法学院",
    author: "金贤宇",
    category: "奇幻",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20young%20swordsman%20with%20magical%20aura%20in%20academy%20setting%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20clean%20white%20background%2C%20epic%20fantasy%20illustration%20style%2C%20professional%20anime%20cover%20art&width=800&height=1120&seq=comic-cover-02&orientation=portrait",
    rating: 9.5,
    views: "980万",
    latestChapter: "第187话",
    updateDate: "2026-07-06",
    description: "在魔法与剑术并存的世界顶级学院中，少年凭借天赋与努力一步步登上巅峰。热血战斗、真挚友情、奇幻冒险，应有尽有！",
    tags: ["奇幻", "热血", "校园"]
  },
  {
    id: 3,
    title: "社长大人请自重",
    author: "李恩智",
    category: "恋爱",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20handsome%20CEO%20man%20and%20beautiful%20employee%20woman%2C%20modern%20office%20setting%2C%20elegant%20and%20mature%20style%2C%20soft%20rose%20and%20cream%20color%20palette%2C%20clean%20minimal%20background%2C%20professional%20romance%20cover%20illustration&width=800&height=1120&seq=comic-cover-03&orientation=portrait",
    rating: 9.6,
    views: "1560万",
    latestChapter: "第215话",
    updateDate: "2026-07-07",
    description: "职场新人遇上帅气社长，从误会到相知相爱。办公室里的甜蜜恋情，让人心跳加速的浪漫职场故事！",
    tags: ["恋爱", "职场", "都市"]
  }
];

export const categoryComics = [
  {
    id: 4,
    title: "恶魔的契约",
    author: "崔允儿",
    category: "奇幻",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20mysterious%20demon%20man%20with%20dark%20wings%2C%20gothic%20atmosphere%2C%20deep%20red%20and%20black%20color%20scheme%2C%20clean%20dark%20minimal%20background%2C%20dramatic%20fantasy%20illustration%20style&width=800&height=1120&seq=comic-cover-04&orientation=portrait",
    rating: 9.3,
    views: "720万",
    latestChapter: "第156话",
    tags: ["奇幻", "暗黑", "恋爱"]
  },
  {
    id: 5,
    title: "校草别跑",
    author: "张美妍",
    category: "校园",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20handsome%20school%20boy%20and%20cute%20girl%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20blue%20color%20palette%2C%20youthful%20and%20sweet%20atmosphere%2C%20clean%20illustration%20style&width=800&height=1120&seq=comic-cover-05&orientation=portrait",
    rating: 9.4,
    views: "890万",
    latestChapter: "第178话",
    tags: ["校园", "恋爱", "青春"]
  },
  {
    id: 6,
    title: "武林至尊",
    author: "赵泰浩",
    category: "武侠",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20powerful%20warrior%20in%20traditional%20hanbok%2C%20dramatic%20fighting%20pose%2C%20traditional%20Korean%20landscape%20background%2C%20earthy%20brown%20and%20gold%20tones%2C%20epic%20oriental%20illustration%20style&width=800&height=1120&seq=comic-cover-06&orientation=portrait",
    rating: 9.6,
    views: "1150万",
    latestChapter: "第234话",
    tags: ["武侠", "热血", "历史"]
  }
];

export const latestUpdates = [
  {
    id: 7,
    title: "星光下的约定",
    author: "韩素希",
    category: "恋爱",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%2C%20couple%20under%20starlit%20night%20sky%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20purple%20and%20navy%20color%20scheme%2C%20clean%20illustration%20with%20stars%2C%20emotional%20love%20story%20cover&width=800&height=1120&seq=comic-cover-07&orientation=portrait",
    rating: 9.2,
    views: "450万",
    latestChapter: "第89话",
  },
  {
    id: 8,
    title: "重生之商业帝国",
    author: "孙泰英",
    category: "都市",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20business%20drama%20manhwa%20cover%2C%20confident%20businessman%20in%20modern%20suit%2C%20city%20skyline%20background%2C%20sophisticated%20gray%20and%20navy%20color%20scheme%2C%20clean%20professional%20illustration%20style%2C%20modern%20urban%20atmosphere&width=800&height=1120&seq=comic-cover-08&orientation=portrait",
    rating: 9.5,
    views: "670万",
    latestChapter: "第145话",
  },
  {
    id: 9,
    title: "妖狐传说",
    author: "柳真雅",
    category: "奇幻",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20supernatural%20fantasy%20manhwa%20cover%2C%20beautiful%20nine-tailed%20fox%20spirit%20woman%2C%20mystical%20forest%20setting%2C%20ethereal%20white%20and%20silver%20color%20palette%2C%20enchanting%20and%20mysterious%20atmosphere%2C%20clean%20oriental%20fantasy%20illustration&width=800&height=1120&seq=comic-cover-09&orientation=portrait",
    rating: 9.4,
    views: "830万",
    latestChapter: "第167话",
  },
  {
    id: 10,
    title: "篮球风云",
    author: "权民秀",
    category: "运动",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20cover%2C%20basketball%20player%20in%20dynamic%20action%20dunking%20pose%2C%20sports%20arena%20background%2C%20energetic%20orange%20and%20white%20color%20scheme%2C%20clean%20sports%20illustration%20style%2C%20competitive%20atmosphere&width=800&height=1120&seq=comic-cover-10&orientation=portrait",
    rating: 9.1,
    views: "560万",
    latestChapter: "第134话",
  }
];

export const rankings = [
  { rank: 1, title: "社长大人请自重", views: "1560万", trend: "up" },
  { rank: 2, title: "我的野蛮王妃", views: "1280万", trend: "up" },
  { rank: 3, title: "武林至尊", views: "1150万", trend: "up" },
  { rank: 4, title: "剑与魔法学院", views: "980万", trend: "down" },
  { rank: 5, title: "校草别跑", views: "890万", trend: "up" },
  { rank: 6, title: "妖狐传说", views: "830万", trend: "up" },
  { rank: 7, title: "恶魔的契约", views: "720万", trend: "down" },
  { rank: 8, title: "重生之商业帝国", views: "670万", trend: "up" },
  { rank: 9, title: "篮球风云", views: "560万", trend: "down" },
  { rank: 10, title: "星光下的约定", views: "450万", trend: "up" }
];

export const categories = [
  { slug: "romance", name: "恋爱", icon: "ri-heart-line", count: 1280, color: "bg-rose-100 text-rose-700" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line", count: 960, color: "bg-amber-100 text-amber-700" },
  { slug: "campus", name: "校园", icon: "ri-book-open-line", count: 850, color: "bg-emerald-100 text-emerald-700" },
  { slug: "urban", name: "都市", icon: "ri-building-2-line", count: 720, color: "bg-sky-100 text-sky-700" },
  { slug: "martial", name: "武侠", icon: "ri-sword-line", count: 540, color: "bg-orange-100 text-orange-700" },
  { slug: "sports", name: "运动", icon: "ri-basketball-line", count: 380, color: "bg-teal-100 text-teal-700" },
  { slug: "horror", name: "悬疑", icon: "ri-ghost-line", count: 290, color: "bg-violet-100 text-violet-700" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line", count: 460, color: "bg-yellow-100 text-yellow-700" }
];

export const testimonials = [
  {
    id: 1,
    name: "小雨",
    username: "@xiaoyu_reads",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cute%20girl%20avatar%20portrait%2C%20soft%20pastel%20colors%2C%20simple%20minimal%20background%2C%20warm%20friendly%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-01&orientation=squarish",
    comment: "韩漫屋真的是我每天必刷的网站！更新速度超快，画质也很清晰。特别喜欢这里的恋爱漫画推荐，每次都能找到合心意的作品，已经推荐给好多朋友了！"
  },
  {
    id: 2,
    name: "星辰大海",
    username: "@oceanstar_kmh",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20handsome%20boy%20avatar%20portrait%2C%20soft%20warm%20colors%2C%20simple%20minimal%20background%2C%20friendly%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-02&orientation=squarish",
    comment: "作为资深韩漫迷，不得不说韩漫屋的漫画库真的很全。从经典老漫到最新连载应有尽有，分类也很清晰，找漫画特别方便。免费的还能看正版，太良心了！"
  },
  {
    id: 3,
    name: "樱花落",
    username: "@sakura_dream",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20beautiful%20girl%20avatar%20portrait%2C%20soft%20pink%20tones%2C%20simple%20minimal%20background%2C%20gentle%20smile%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-03&orientation=squarish",
    comment: "页面设计简洁好看，阅读体验很流畅。最赞的是每天都有更新提醒，不会错过喜欢的漫画更新。客服反馈也很快，有问题随时能解决，体验感满分！"
  },
  {
    id: 4,
    name: "剑客无名",
    username: "@swordmaster_kr",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cool%20boy%20avatar%20portrait%2C%20dark%20tone%20colors%2C%20simple%20minimal%20background%2C%20confident%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-04&orientation=squarish",
    comment: "武侠类韩漫太精彩了！韩漫屋的武侠分类做得很好，推荐算法也很准，每次推荐的漫画都是我喜欢的类型。已经连续签到180天了，真爱粉无疑！"
  },
  {
    id: 5,
    name: "薄荷糖",
    username: "@mint_candy_read",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20sweet%20girl%20avatar%20portrait%2C%20mint%20green%20tones%2C%20simple%20minimal%20background%2C%20bright%20smile%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-05&orientation=squarish",
    comment: "从第一次打开韩漫屋就被圈粉了！不用注册也能看很多漫画，想看更多注册也超简单。漫画的翻译质量很高，读起来很流畅，完全不输付费平台的体验。"
  },
  {
    id: 6,
    name: "夜雨声烦",
    username: "@nightreader_k",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20mysterious%20girl%20avatar%20portrait%2C%20dark%20purple%20tones%2C%20simple%20minimal%20background%2C%20cool%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-06&orientation=squarish",
    comment: "悬疑类韩漫爱好者狂喜！这里的悬疑漫画资源特别丰富，而且更新速度比同类平台快多了。半夜追更的快乐谁懂啊，感谢韩漫屋让我找到这么多好作品！"
  }
];

export const statsData = [
  { value: "10万+", label: "漫画资源" },
  { value: "500万+", label: "月活用户" },
  { value: "98%", label: "用户好评率" },
  { value: "每日更新", label: "200+部" }
];